import script from "./PasswordResetsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordResetsCard.vue?vue&type=script&setup=true&lang=js"

import "./PasswordResetsCard.vue?vue&type=style&index=0&id=b2092044&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2092044"]])

export default __exports__